import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "align-text-justify",
  "use": "align-text-justify-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"align-text-justify\">\r\n<path d=\"M0 3.5H15M0 11.5H15M0 7.5H15\" stroke=\"#409EFF\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol